import { DE_LOCALE } from './i18n';
import { getCookie } from '../api/lendingApi/lendingApiQueries';

export const isIwocaDE = () => {
  const host = window.location.host;

  const isDELocale =
    hostIncludesDeLocale(host) || getCookie('locale') === DE_LOCALE;

  return isDELocale;
};

export const hostIncludesDeLocale = (host?: string) => {
  if (!host) return false;

  return host.includes(`.${DE_LOCALE}`);
};
